import { LANGS, setLanguage } from '../i18n';
import { useGame } from '../store';

/**
 * The language buttons: each language by its own name (`large`), or by its code (the title
 * screen's corner, the legal pages). Russian, French and German load when picked.
 */
export function LanguageSwitch({ large = false }: { large?: boolean }) {
  const lang = useGame((s) => s.lang);
  return (
    <div className={`lang-switch ${large ? 'large' : ''}`}>
      {LANGS.map((l) => (
        <button
          type="button"
          key={l.id}
          lang={l.id}
          title={l.name}
          className={l.id === lang ? 'active' : ''}
          onClick={() => void setLanguage(l.id)}
        >
          {large ? l.name : l.id.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
